<template>
  <LoadingModal :show="loading" :label="loadingLabel" :overlay="true" />

    <!-- <div class="column">
      <div class="chart-block">
        <h3>Укупно предвиђена средства</h3>
        <div class="centerStats chart-wrapper">
          <canvas ref="monthlyChart3"></canvas>
        </div>
      </div>
    </div> -->
    <div class="column">
      <div class="chart-block">
        <h3  class="give-breath">Додељења средства по годинама</h3>
        <div class="centerStats chart-wrapper">
          <canvas ref="monthlyChart2"></canvas>
        </div>
      </div>
    </div>
  
  <div class="column">
    <div class="chart-block">
      <h3 class="give-breath">Ранг листа добитника највиших средстава</h3>
      <div class="centerStats chart-wrapper">
        <canvas ref="TopProjectSubmitterByAmount"></canvas>
      </div>
    </div>
  </div>

</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import axios from 'axios'
import Chart from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { baseUrl } from '../env'
import LoadingModal from '@/components/LoadingModal.vue'
import { useRoute } from "vue-router";
const route = useRoute();
Chart.register(ChartDataLabels)

const monthlyChart2 = ref(null)
//const monthlyChart3 = ref(null)
const loading = ref(true)
const loadingLabel = ref('Учитавање статистике...')
const TopProjectSubmitterByAmount = ref(null)
const selectedTownship = ref(null)
// ✅ Custom plugin to add space between legend and chart
const legendGapPlugin = {
  id: 'legendGap',
  beforeInit(chart) {
    const originalFit = chart.legend.fit;
    chart.legend.fit = function fit() {
      originalFit.bind(chart.legend)();
      this.height += 50; // change 20 to desired gap in px
    };
  }
};

const chartInstances = {
  monthly2: ref(null),
  //monthly3: ref(null),
    topProjectSubmitterByAmount: ref(null),
}

// Destroy chart instance if exists
function destroyChart(key) {
  if (chartInstances[key]?.value) {
    chartInstances[key].value.destroy()
    chartInstances[key].value = null
  }
}

const yAxisFormat = {
  ticks: {
    callback(value) {
      if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + 'B'
      if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + 'M'
      if (value >= 1_000) return (value / 1_000).toFixed(0) + 'K'
      return value
    }
  }
}

// Color helpers
// function getColorForYear(yearIndex, totalYears) {
//   const hue = (yearIndex / totalYears) * 360
//   return `hsl(${hue}, 70%, 50%)`
// }
// function getColorForYear(yearIndex, totalYears, isActive = false) {
//   const hue = 210
//   const lightness = isActive
//     ? 75 // brighter when active
//     : 40 + (yearIndex / totalYears) * 25
//   return `hsl(${hue}, 70%, ${lightness}%)`
// }
function getColorForValue(value, minValue, maxValue) {
  const hue = 210 // base color (blue)
  // normalize value between 0 and 1
  const ratio = (value - minValue) / (maxValue - minValue)
  // clamp ratio to prevent overflow
  const clamped = Math.max(0, Math.min(1, ratio))
  // interpolate lightness (lighter for low, darker for high)
  const lightness = 80 - clamped * 40 // range: 80% → 40%
  return `hsl(${hue}, 70%, ${lightness}%)`
}
function hslToRgba(hsl, alpha) {
  return hsl.replace('hsl', 'hsla').replace(')', `, ${alpha})`)
}

// --- LOCAL STORAGE CACHING ---
const CACHE_KEY_BASE = 'chartsData'
const CACHE_TTL = 10 * 60 * 1000 // 10 minutes

async function fetchStat(url, returnRaw = false) {
  const res = await axios.get(`${baseUrl}${url}`)
  const data = res.data

  const response = (value) => returnRaw ? [value, data] : value

  if (typeof data === 'number') return response(data)
  if (typeof data.value === 'number') return response(data.value)
  if (typeof data.count === 'number') return response(data.count)
  if (Array.isArray(data)) return response(data.length)

  return response(data) // fallback
}

async function fetchChartsData(allTownship = null) {
  allTownship = selectedTownship.value ? selectedTownship.value.id : null
  const cacheKey = `${CACHE_KEY_BASE}_${allTownship || 'all'}`
  const cached = JSON.parse(localStorage.getItem(cacheKey) || '{}')
  const now = Date.now()

  if (cached.data && cached.timestamp && (now - cached.timestamp) < CACHE_TTL) {
    console.log(`🟢 Loaded from cache: ${cacheKey}`)
    return cached.data
  }

  console.log(`🟠 Fetching fresh data for: ${cacheKey}`)
  const res = await axios.get(`${baseUrl}/query/25/null/null/${allTownship || ''}`)
  const data =
    res.data.value ||
    res.data.count ||
    (Array.isArray(res.data) ? res.data.length : 0) ||
    res.data

  localStorage.setItem(cacheKey, JSON.stringify({ data, timestamp: now }))
  return data
}

function initSelectedTownship() {
  const jedinicaId = route.query.jedinica
  const jedinicaName = route.query.naziv || null

  if (jedinicaId) {
    selectedTownship.value = {
      id: jedinicaId,
      name: jedinicaName || `Јединица ${jedinicaId}`
    }
  } else {
    selectedTownship.value = null
  }
}

// Load both charts
async function loadAllCharts(datefrom, dateto) {
  try {
    const allTownship = selectedTownship.value ? selectedTownship.value.id : null
    const d = new Date()
    const from = route.query.od || datefrom || '01.01.1971.'
    const to = route.query.do || dateto || `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}.`

    loading.value = true

    const groupedMonthlyAllocatedFundsAvg = await fetchChartsData()

    // Extract unique years
    const allYears = [...new Set(Object.values(groupedMonthlyAllocatedFundsAvg).map(i => i.year))]

    // Compute yearly totals
    const yearlyTotals = {}
    Object.values(groupedMonthlyAllocatedFundsAvg).forEach(item => {
      if (!yearlyTotals[item.year]) yearlyTotals[item.year] = { totalAloc: 0, totalFunds: 0 }
      yearlyTotals[item.year].totalAloc += item.totalAloc
      yearlyTotals[item.year].totalFunds += item.totalFunds
    })

    // Generate colors
    // const yearColors = {}
    // allYears.forEach((year, idx) => {
    //   yearColors[year] = getColorForYear(idx, allYears.length)
    // })
    // ✅ Generate color scale based on values
    const values = allYears.map(year => yearlyTotals[year]?.totalAloc || 0)
    const minValue = Math.min(...values)
    const maxValue = Math.max(...values)
    const yearColors = {}

    allYears.forEach((year) => {
      const val = yearlyTotals[year]?.totalAloc || 0
      yearColors[year] = getColorForValue(val, minValue, maxValue)
    })

    const datasetsAllocated = [
      {
        label: "Додељена средства",
        data: allYears.map(year => yearlyTotals[year]?.totalAloc || 0),
        backgroundColor: allYears.map(year => hslToRgba(yearColors[year], 0.8))
      }
    ]

    // const datasetsPredvidjena = [
    //   {
    //     label: "Предвиђена средства",
    //     data: allYears.map(year => yearlyTotals[year]?.totalFunds || 0),
    //     backgroundColor: allYears.map(year => hslToRgba(yearColors[year], 0.4))
    //   }
    // ]

    // Render monthly2 chart (Allocated)
    destroyChart('monthly2')
    chartInstances.monthly2.value = new Chart(monthlyChart2.value.getContext('2d'), {
      type: 'bar',
      data: { labels: allYears, datasets: datasetsAllocated },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'top' },
          datalabels: {
            display: ctx => ctx.dataset.data[ctx.dataIndex] !== null,
            formatter: val => isNaN(val) ? '' : 
                     (val > 1000000000) ?
                       (val / 1000000000).toFixed(1).replace('.', ',') + 'B'
                    : 
                       (val / 1000000).toFixed(1).replace('.', ',') + 'M'   
                  ,
                  anchor: 'end',
                  align: 'top',
          }
        }
        ,scales: { y: yAxisFormat }
      },
            // ✅ Pass custom plugin here, not in options
            plugins: [legendGapPlugin]
    })

    //// Render monthly3 chart (Predviđena)
    // destroyChart('monthly3')
    // chartInstances.monthly3.value = new Chart(monthlyChart3.value.getContext('2d'), {
    //   type: 'bar',
    //   data: { labels: allYears, datasets: datasetsPredvidjena },
    //   options: {
    //     responsive: true,
    //     maintainAspectRatio: false,
    //     plugins: {
    //       legend: { position: 'top' },
    //       datalabels: {
    //         display: ctx => ctx.dataset.data[ctx.dataIndex] !== null,
    //         formatter: val => isNaN(val) ? '' : `${(val / 1_000_000).toFixed(0)}M`
    //       }
    //     }
    //   }
    // })

     const { rows, chart: amountTopSubmittersChart } = await fetchStat(`/query/24/${from}/${to}/${allTownship || ''}?type=amount`);

    if (amountTopSubmittersChart && amountTopSubmittersChart.labels && amountTopSubmittersChart.datasets && amountTopSubmittersChart.datasets.length > 0) {
      if (TopProjectSubmitterByAmount.value) {
        destroyChart('topProjectSubmitterByAmount')
        chartInstances.topProjectSubmitterByAmount.value =
          new Chart(TopProjectSubmitterByAmount.value.getContext('2d'), {
            type: 'bar',
            data: {
              labels: amountTopSubmittersChart.labels.map(label => {
                return label.length > 20 ? `${label.substring(0, 20)?.trim()}...` : label;
              }),
              datasets: amountTopSubmittersChart.datasets
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                tooltip: {
                  callbacks: {
                    title: function (context) {
                      const index = context[0].dataIndex;
                      return amountTopSubmittersChart.labels[index];
                    }
                  }
                },
                datalabels: {
                  color: '#000',
                  anchor: 'end',
                  align: 'top',
                  // font: {
                  //   weight: 'normal'
                  // },
                  formatter: (value) => {
                    if (value > 1000000000) {
                      return (value / 1000000000).toFixed(1).replace('.', ',') + 'B';
                    } else {
                      return (value / 1000000).toFixed(1).replace('.', ',') + 'M';
                    }
                  }
                }
              },
              onClick: (evt, elements) => {
                if (elements.length > 0) {
                  const idx = elements[0].index
                  const item = rows[idx]
                  if (item.submitter) {
                    const url = `/pretraga/podnosioc-projekta?submitter=${item.submitter}&jedinica=${allTownship || ''}`
                    //window.location.href = url
                     window.open(url, '_blank', 'noopener,noreferrer');
                  }
                }
              }
              ,scales: { y: yAxisFormat }
            },
            // ✅ Pass custom plugin here, not in options
            plugins: [legendGapPlugin]
          })
      }
    }

    loading.value = false
  } catch (e) {
    console.error('Statistika greska:', e)
    loading.value = false
  }
}

watch(() => route.query, () => {
  initSelectedTownship()
  loadAllCharts()
}, { deep: true })

// 👇 Na inicijalizaciji proveri da li postoji ?jedinica= u URL-u
onMounted(async () => {
  initSelectedTownship()
  await loadAllCharts()
})


</script>

<style scoped>
.homeStats {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.centerStats {
  text-align: center;
  margin: 0 auto;
}
.chart-block {
  padding-top: 15px;
}
.chart-wrapper {
  max-width: 100%;
  width: 100%;
  height: 300px;
  position: relative;
}
.two-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  padding: 20px;
}
.column {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
@media (max-width: 768px) {
  .two-columns {
    grid-template-columns: 1fr;
  }
}
canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
